var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 9.5999C3.19922 7.83259 4.63191 6.3999 6.39922 6.3999H15.9992C17.7665 6.3999 19.1992 7.83259 19.1992 9.5999V22.3999C19.1992 24.1672 17.7665 25.5999 15.9992 25.5999H6.39922C4.63191 25.5999 3.19922 24.1672 3.19922 22.3999V9.5999Z",
    fill: "#284254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2837 11.3688C22.7416 11.6398 22.3992 12.1939 22.3992 12.7999V19.1999C22.3992 19.8059 22.7416 20.36 23.2837 20.631L26.4837 22.231C26.9797 22.479 27.5687 22.4525 28.0404 22.1609C28.5121 21.8694 28.7992 21.3544 28.7992 20.7999V11.1999C28.7992 10.6454 28.5121 10.1304 28.0404 9.83886C27.5687 9.54733 26.9797 9.52083 26.4837 9.76882L23.2837 11.3688Z",
    fill: "#284254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMov);
export default __webpack_public_path__ + "static/media/mov.76b6003a9c5085c7a948bbba110e2391.svg";
export { ForwardRef as ReactComponent };